<div class="progress-table-phase" >
		<div *ngIf="allColumns"id="progresstable" class="table-responsive-lg">
			<app-component-loader
				[loading]="LoaderService.loadingProgressTable"
			></app-component-loader>

			<div class="tw-relative">
				<div class="tw-flex tw-items-center tw-flex-nowrap tw-gap-2 tw-mb-2 tw-p-2 tw-bg-gradient-to-r tw-from-gray-50 tw-to-gray-100 tw-rounded-lg tw-shadow-sm tw-overflow-x-auto">
					<div class="progress-table-labels tw-flex tw-items-center tw-flex-shrink-0">
					</div>
					<div class="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0">
						<div class="tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-sm">
							<i class="fa fa-search tw-text-gray-500 tw-text-xs"></i>
							<input
								type="text"
								[value]="filterText"
								(input)="onFilterInput($event)"
								placeholder="Filter students..."
								class="tw-w-72 tw-px-2 tw-py-0.5 tw-text-xs tw-border-0 focus:tw-outline-none focus:tw-ring-0"
							/>
						</div>

						<button
							*ngIf="filterText"
							(click)="clearFilter()"
							class="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-gray-700  tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-sm hover:tw-bg-gray-50 tw-transition-colors tw-whitespace-nowrap "
							type="button"
							title="Clear filter"
						>
							<i class="fa fa-times"></i>
							Clear
						</button>
					</div>

					<!-- Legends and Column Dropdown -->
					<div class="tw-flex tw-items-center tw-flex-nowrap tw-gap-2 tw-ml-auto tw-flex-shrink-0">
						<div class="progress-table-legends tw-flex tw-items-center tw-flex-nowrap tw-gap-1.5">
							<span id="baseline" class="badge badge-light ml-2 my-1" style="background-color: #ddd;">
								<span class="baseline-color" style="line-height: 1; vertical-align: middle;">
								Score Recorded at Baseline
								</span>
							</span>

							<span id="lastyearlegend" class="badge badge-light ml-2 my-1" style="background-color: #ddd;">
								<span class="last-year-color" style="line-height: 1; vertical-align: middle;">
								Previous Year Score
								</span>
							</span>

							<span class="tw-inline-flex tw-items-center tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 tw-rounded-md tw-whitespace-nowrap" *ngIf="rsp.media.is_mobile">
								TA = Times Assessed
							</span>
							<span class="tw-inline-flex tw-items-center tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 tw-rounded-md tw-whitespace-nowrap" *ngIf="rsp.media.is_mobile">
								LA = Last Assessment
							</span>
						</div>

						<div class="progress-table-legends tw-flex tw-items-center tw-relative tw-flex-shrink-0">
							<button
								class="noprint column-dropdown-button tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-rounded-md tw-transition-colors tw-whitespace-nowrap tw-shadow-sm tw-bg-[#6b6b6b] tw-text-white hover:tw-bg-blue-700"
								type="button"
								(click)="columnDropdownOpen = !columnDropdownOpen">
								<i class="fa fa-columns"></i>
								Show/Hide Columns
								<i class="fa fa-chevron-down tw-text-xs" [class.tw-rotate-180]="columnDropdownOpen"></i>
							</button>
						</div>
					</div>
				</div>
				<div
					*ngIf="columnDropdownOpen"
					class="column-dropdown-menu tw-absolute tw-right-2 tw-top-full tw-mt-1 tw-z-[1000] tw-w-56 tw-bg-white tw-rounded-md tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none"
					style="z-index: 1000;">
					<div class="tw-py-1" role="menu">
						<div class=" tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wider tw-border-b tw-border-gray-200">
							Columns
						</div>
						<div
							*ngFor="let column of hidableColumns"
							class="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-100 tw-cursor-pointer tw-transition-colors"
							(click)="toggleHideColumn(column)">
							<div class="tw-w-4 tw-h-4 tw-border-2 tw-rounded tw-flex tw-items-center tw-justify-center tw-transition-colors"
								[ngClass]="column.visible ? 'tw-border-blue-600 tw-bg-blue-600' : 'tw-border-gray-300'">
								<i *ngIf="column.visible" class="fa fa-check tw-text-white tw-text-xs"></i>
							</div>
							<span class="tw-flex-1">{{ getColumnLabel(getColumnKey(column)) }}</span>
							<i class="fa tw-text-gray-400" [ngClass]="column.visible ? 'fa-eye' : 'fa-eye-slash'"></i>
						</div>
					</div>
				</div>
			</div>

			<table *ngIf="reportData" class="progress-data-table tw-w-full tw-text-sm tw-text-center tw-border-collapse">
				<tr class="progress-data-row tw-bg-gray-100">
					<th
						rowspan="2"
						(click)="setSelectedColumn(this.allColumns.lastNameColumn)"
						class="table-clickable tw-px-3 tw-py-3 tw-font-semibold tw-text-gray-700 tw-border tw-border-gray-300 tw-bg-gray-50 hover:tw-bg-gray-100 tw-transition-colors"
						style="width: 12.5%"
						[ngClass]="!rsp.media.is_mobile ? 'tw-truncate' : '' "
					>
						<div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
							<span
								*ngIf="this.allColumns?.lastNameColumn.selected; else NotSorting"
								class="fa table-sorter tw-text-blue-600"
								[ngClass]="this.allColumns.lastNameColumn.isAscending ? 'fa-caret-up' : 'fa-caret-down' "
							></span>
							<ng-template #NotSorting>
								<span class="fa fa-arrows-v tw-text-gray-400"></span>
							</ng-template>
							<span class="table-space">Last Name</span>
						</div>
					</th>

					<th
						rowspan="2"
						(click)="setSelectedColumn(this.allColumns.firstNameColumn)"
						class="table-clickable tw-px-3 tw-py-3 tw-font-semibold tw-text-gray-700 tw-border tw-border-gray-300 tw-bg-gray-50 hover:tw-bg-gray-100 tw-transition-colors"
						style="width: 12.5%;"
						[ngClass]="(!rsp.media.is_mobile ? 'tw-truncate' : '') + ' ' + (this.allColumns.firstNameColumn.visible ? '' : 'tw-hidden')"
					>
						<div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
							<span
								*ngIf="this.allColumns?.firstNameColumn.selected; else NotSorting"
								class="fa table-sorter tw-text-blue-600"
								[ngClass]="this.allColumns.firstNameColumn.isAscending ? 'fa-caret-up' : 'fa-caret-down' "
							></span>
							<ng-template #NotSorting>
								<span class="fa fa-arrows-v tw-text-gray-400"></span>
							</ng-template>
							<span class="table-space">First Name</span>
						</div>
					</th>

					<th
						rowspan="2"
						(click)="setSelectedColumn(this.allColumns.gradeColumn)"
						class="grade-column table-clickable tw-px-3 tw-py-3 tw-font-semibold tw-text-gray-700 tw-border tw-border-gray-300 tw-bg-gray-50 hover:tw-bg-gray-100 tw-transition-colors tw-whitespace-nowrap"
						[ngClass]="this.allColumns.gradeColumn.visible ? '' : 'tw-hidden' "
					>
						<div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
							<span
								*ngIf="this.allColumns?.gradeColumn.selected; else NotSorting"
								class="fa table-sorter tw-text-blue-600"
								[ngClass]="this.allColumns.gradeColumn.isAscending ? 'fa-caret-up' : 'fa-caret-down' "
							></span>
							<ng-template #NotSorting>
								<span class="fa fa-arrows-v tw-text-gray-400"></span>
							</ng-template>
							<span *ngIf="!rsp.media.is_mobile" class="table-space">Grade</span>
							<span *ngIf="rsp.media.is_mobile" class="table-space">G</span>
						</div>
					</th>

					<th
						rowspan="2"
						(click)="setSelectedColumn(this.allColumns.timesAssessedColumn)"
						class="table-clickable tw-px-3 tw-py-3 tw-font-semibold tw-text-gray-700 tw-border tw-border-gray-300 tw-bg-gray-50 hover:tw-bg-gray-100 tw-transition-colors"
						[ngClass]="this.allColumns.timesAssessedColumn.visible ? '' : 'tw-hidden' "
					>
						<div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
							<span
								*ngIf="this.allColumns?.timesAssessedColumn.selected; else NotSorting"
								class="fa table-sorter tw-text-blue-600"
								[ngClass]="this.allColumns.timesAssessedColumn.isAscending ? 'fa-caret-up' : 'fa-caret-down' "
							></span>
							<ng-template #NotSorting>
								<span class="fa fa-arrows-v tw-text-gray-400"></span>
							</ng-template>
							<span *ngIf="!rsp.media.is_mobile" class="table-space">Times Assessed</span>
							<span *ngIf="rsp.media.is_mobile" class="table-space">TA</span>
						</div>
					</th>
					<th
						rowspan="2"
						(click)="setSelectedColumn(this.allColumns.dateAssessedColumn)"
						class="table-clickable tw-px-3 tw-py-3 tw-font-semibold tw-text-gray-700 tw-border tw-border-gray-300 tw-bg-gray-50 hover:tw-bg-gray-100 tw-transition-colors"
						[ngClass]="(rsp.media.is_mobile == true ? 'tw-w-12' : '') + ' ' + (this.allColumns.dateAssessedColumn.visible ? '' : 'tw-hidden')"
					>
						<div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
							<span
								*ngIf="this.allColumns?.dateAssessedColumn.selected else NotSorting"
								class="fa table-sorter tw-text-blue-600"
								[ngClass]="this.allColumns.dateAssessedColumn.isAscending ? 'fa-caret-up' : 'fa-caret-down'"
							></span>
							<ng-template #NotSorting>
								<span class="fa fa-arrows-v tw-text-gray-400"></span>
							</ng-template>
							<span *ngIf="!rsp.media.is_mobile" class="table-space">Last Assessment</span>
							<span *ngIf="rsp.media.is_mobile" class="table-space">LA</span>
						</div>
					</th>
					<th
						[attr.colspan]="challengeData.challengeCount"
						(click)="setSelectedColumn(this.allColumns.allChallengesColumn)"
						class="tw-px-3 tw-py-3 tw-font-semibold tw-text-gray-700 tw-border tw-border-gray-300 tw-bg-gray-50 hover:tw-bg-gray-100 tw-transition-colors tw-cursor-pointer"
					>
						<div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
							Score by Challenge
							<span
								*ngIf="this.allColumns.allChallengesColumn.selected"
								class="fa tw-text-blue-600"
								[ngClass]="this.allColumns.allChallengesColumn.isAscending ? 'fa-caret-up' : 'fa-caret-down'">
							</span>
						</div>
					</th>
				</tr>
				<tr class="tw-bg-gray-50">
					<th
						*ngFor="let eachChallenge of challengeData.challenges; index as i"
						rowspan="1"
						(click)="setChallengeSort(eachChallenge.id)"
						class="labelcolor-{{ eachChallenge.testId }} tw-truncate tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-cursor-pointer hover:tw-bg-opacity-80 tw-transition-colors"
						style="min-width: 18px;"
					>
						<div class="challenge-header">
							<div class="challenge-header-element fa fa-caret-up compressed-sorting-arrows tw-text-blue-600"
								[style.visibility]="( this.allColumns.challengeIdColumn.selected
														&& this.allColumns.challengeIdColumn.isAscending
														&& this.allColumns.challengeIdColumn.selectedChallengeId == eachChallenge.id ) ? 'visible' : 'hidden !important' ">
							</div>
							<div
							[ngbPopover]="challengeTooltip"
								popoverTitle=""
								triggers="mouseenter:mouseleave click"
								placement="top"
							class="challenge-header-element tw-font-semibold"> {{ i + 1 }} </div>
							<div class="challenge-header-element fa fa-caret-down compressed-sorting-arrows tw-text-blue-600"
								[style.visibility]="( this.allColumns.challengeIdColumn.selected
														&& !this.allColumns.challengeIdColumn.isAscending
														&& this.allColumns.challengeIdColumn.selectedChallengeId == eachChallenge.id ) ? 'visible' : 'hidden !important' ">
							</div>
						</div>

						<ng-template #challengeTooltip>
							<h3 class="popover-header labelcolor-{{ eachChallenge.testId }}">
								<b>{{ eachChallenge.label }}</b>
							</h3>
							<div class="popover-body">
								{{ eachChallenge.question }}
							</div>
						</ng-template>
					</th>
				</tr>
				<!-- No Results Message -->
				<tr *ngIf="filterText && filterText.trim() !== '' && (!studentData || studentData.length === 0)" class="tw-bg-gray-50">
					<td [attr.colspan]="getTotalColumnCount()" class="tw-px-6 tw-py-12 tw-text-center tw-border tw-border-gray-300">
						<div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
							<i class="fa fa-search tw-text-4xl tw-text-gray-400"></i>
							<div class="tw-text-gray-600 tw-font-medium">
								No students found matching "{{ filterText }}"
							</div>
							<div class="tw-text-sm tw-text-gray-500">
								Try adjusting your search terms or
								<button
									(click)="clearFilter()"
									class="tw-text-blue-600 hover:tw-text-blue-800 tw-underline tw-font-medium"
								>
									clear the filter
								</button>
							</div>
						</div>
					</td>
				</tr>
				<tr *ngFor="let eachStudent of studentData; index as j" class="hover:tw-bg-gray-50 tw-transition-colors">
					<td
						class="tw-px-2 tw-text-left tw-border tw-border-gray-300 tw-cursor-pointer hover:tw-bg-blue-50 tw-transition-colors"
						(click)="goToDash(eachStudent.student)"
					>
						{{ eachStudent.student.lname}}
					</td>

					<td
						class=" tw-px-2 tw-text-left tw-border tw-border-gray-300 tw-cursor-pointer hover:tw-bg-blue-50 tw-transition-colors"
						(click)="goToDash(eachStudent.student)"
						[ngClass]="this.allColumns.firstNameColumn.visible ? '' : 'tw-hidden' "
					>
						{{eachStudent.student.fname}}
					</td>

					<td
						class="grade-column tw-border tw-border-gray-300"
						[ngClass]="this.allColumns.gradeColumn.visible ? '' : 'tw-hidden' ">
						{{eachStudent.student.grade}}
					</td>

					<td
						class=" tw-border tw-border-gray-300"
						[ngClass]="this.allColumns.timesAssessedColumn.visible ? '' : 'tw-hidden' ">
						{{ eachStudent.totalTimesAssessed }}
					</td>
					<td
						class=" tw-border tw-border-gray-300"
						[ngClass]="this.allColumns.dateAssessedColumn.visible ? '' : 'tw-hidden' ">
						{{ eachStudent.totalLastAssessed }}
					</td>
					<td
						*ngFor="
							let eachChallenge of challengeData.challenges;
							let isFirst = first;
							index as k
						"
						class=" tw-border tw-border-gray-300"
						[ngClass]="
							setCellClass(eachStudent, eachChallenge) +
							' ' +
							setBorder(challengeData, k)
						"
					>
						<div
							[ngClass]="
								eachStudent.scores[eachChallenge.id]?.type == scoreType.PLACEMENT
									? 'lastYearScore'
									: ''
							"
						>
							{{ eachStudent.scores[eachChallenge.id]?.score }}
						</div>
						<div
							*ngIf="
								scoreHelper.isLastYearStudentScore(eachStudent, eachChallenge.id)
							"
							class="lastYearScore"
						>
							{{ eachStudent.previousScores[eachChallenge.id]?.score }}
						</div>
					</td>
				</tr>

				<tr class="progress-table-footer-row tw-bg-gray-100 tw-font-semibold">
					<td [attr.colspan]="leftFooterColumnCount" class="tw-px-3 tw-py-3 tw-p tw-text-left tw-border tw-border-gray-300">
						Total Students: {{ classSize }}
					</td>
					<td [attr.colspan]="rightFooterColumnCount" class="tw-px-3 tw-py-3 tw-text-right tw-border tw-border-gray-300">
						Total Students Mastered
					</td>
					<td
						*ngFor="let eachChallenge of challengeData.challenges"
						class="labelcolor-{{ eachChallenge.testId }} tw-px-3 tw-py-3 tw-border tw-border-gray-300"
					>
						{{ eachChallenge.numOfMaster }}
					</td>
				</tr>
			</table>
		</div>
	</div>

